import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { withRouter, Link } from "react-router-dom";
import { AvForm, AvField } from "availity-reactstrap-validation";

import LoginWithFacebook from "./OAuth/LoginWithFacebook";
import LoginWithGoogle from "./OAuth/LoginWithGoogle";
import * as modalConstants from "../../../constants/modal.constants.js";
import {
  configurationsConstants,
  EMPTY_STRING,
  redirectAfterLogin,
} from "../../../constants";
import { loginActions } from "../../../redux/actions";
import SideImage from "../../../shared/components/SideImage/SideImage.jsx";
import InputField from "../../../shared/components/Fields/InputField.jsx";
import { assetsConstants } from "../../../constants/assets.constants.js";
import CheckBox from "../../../shared/components/Fields/CheckBox.jsx";

const LogInForm = (props) => {
  /* eslint-disable */
  const [shouldRemember, setShouldRemember] = useState(false);
  const { t } = useTranslation("common");

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  // when user clicks on Login button
  const handleSubmit = (event, values) => {
    props.onLoginClick({ ...values });
  };

  // navigate to screen after login
  useEffect(() => {
    if (props?.authentication?.isAuthenticated) {
      // if we have a screen to redirect, i-e we came here by clicking a deep link,
      // but were logged out, so after login we will go to that screen.
      const savedPath = sessionStorage.getItem(redirectAfterLogin);
      if (savedPath) {
        window.location.replace(
          `${process.env.REACT_APP_HOST_BASE_URL}${savedPath}`
        );
      } else {
        window.location.replace(
          `${process.env.REACT_APP_HOST_BASE_URL}/CustomerDashboard`
        );
      }
    } else if (props.isShutterbAuthenticated) {
      sessionStorage.removeItem(redirectAfterLogin);
      window.location.replace(
        `${process.env.REACT_APP_HOST_BASE_URL}/Shutterbdashboard`
      );
    }
    // eslint-disable-next-line
  }, [props.authentication.isAuthenticated, props.isShutterbAuthenticated]);

  return (
    <>
      <SideImage
        imageUrl={assetsConstants.CUSTOMER_LOGIN_IMAGE_URL}
        showBackButton={props.showBackButton ?? true}
        isAllowModal={props.isAllowModal}
      >
        <div
          className={`login-form ${
            props.isAllowModal ? "login-form-modal px-3 pb-4" : EMPTY_STRING
          }`}
        >
          {!props.isPage && (
            <button
              id="cancel-icon"
              onClick={() => props.setIsModalOpen(false)}
            >
              <span>X</span>
            </button>
          )}
          <AvForm
            className="form_Display_Flex"
            onValidSubmit={handleSubmit}
            autoComplete="off"
          >
            <div className={`${props.isAllowModal ? "pt-4" : "pt-3 pt-sm-5"}`}>
              <div className="d-flex align-items-center position-relative  my-md-2 my-4">
                <h2 className="text-center form-heading w-100 mb-0">login</h2>
              </div>
              <p className="p-0 pt-3 m-0 text-black-thin mb-3">
                welcome! please fill in your email and password below to sign
                into your account.
              </p>
            </div>
            <div className="form__form-group">
              <div className="form__form-group-field">
                <div className="">
                  <AvField
                    type="email"
                    label={
                      <span className="form-label label-content-600">
                        email
                      </span>
                    }
                    name="userName"
                    placeholder="email"
                    className="form-control"
                    maxLength={configurationsConstants.EMAIL_INPUT_LENGTH}
                    pattern="^[a-z,A-Z,0-9,!@#$%^&*_=+-].{3,}$"
                    validate={{
                      required: {
                        value: true,
                        errorMessage: t("this_field_is_required"),
                      },
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="form__form-group">
              <div className="form__form-group-field">
                <div>
                  <InputField
                    type="password"
                    label={
                      <span className="form-label label-content-600">
                        password
                      </span>
                    }
                    name="password"
                    placeholder="password"
                    maxLength={configurationsConstants.PASSWORD_INPUT_LENGTH}
                    errorMessage={t("this_field_is_required")}
                    pattern="^[a-z,A-Z,0-9,!@#$%^&*_=+-].{3,}$"
                    validate={{
                      required: {
                        value: true,
                        errorMessage: t("this_field_is_required"),
                      },
                    }}
                  ></InputField>
                </div>
              </div>
            </div>
            <div className="form__form-group align-self-end d-flex justify-content-between align-items-center">
              {/* Checkbox aur uska label ko ek FormGroup mein wrap karein */}
              <CheckBox
                containerClass={"teal-checkbox"}
                checked={shouldRemember}
                setChecked={setShouldRemember}
                labelText="remember me"
              />
              <p className="p-0 py-sm-1 py-md-1 m-0">
                <Link
                  className="teal-text forgot-password-text"
                  to={{
                    pathname: "/",
                    state: {
                      formSelect: modalConstants.FORGOT_PASSWORD_FORM,
                    },
                  }}
                  onClick={(e) => {
                    if (props.isAllowModal) {
                      e.preventDefault();
                      props?.setFormSelect(modalConstants.FORGOT_PASSWORD_FORM);
                    }
                  }}
                >
                  forgot password?
                </Link>
              </p>
            </div>
            <div className="form__form-group mb-2">
              <div className="form__form-group-field">
                <div className="account__btns ml-0">
                  <button
                    type="submit"
                    className="button-common button-fill btn-h36 w-100 mt-2"
                  >
                    {t("login")}
                  </button>
                </div>
              </div>
            </div>
          </AvForm>
          <div>
            <div className="form__form-group d-flex justify-content-between p-0 py-sm-1 py-md-2 m-0">
              <hr className="login-form-divider" />
              or
              <hr className="login-form-divider" />
            </div>

            <div className="form__form-group mb-2">
              <div className="form__form-group-field">
                <LoginWithGoogle
                  onLoginWithGoogleClick={props.onLoginWithGoogleClick}
                />
              </div>
            </div>
            <div className="form__form-group mb-2">
              <div className="form__form-group-field">
                <LoginWithFacebook
                  onLoginWithFacebookClick={props.onLoginWithFacebookClick}
                />
              </div>
            </div>
            <div className="form__form-group d-flex">
              <p className="p-0 m-0 mt-2 text">
                don't have an account?{" "}
                <Link
                  to={{
                    pathname: "/",
                    state: {
                      formSelect: modalConstants.SIGNUP_FORM,
                    },
                  }}
                  onClick={(e) => {
                    if (props.isAllowModal) {
                      e.preventDefault();
                      props?.setFormSelect(modalConstants.SIGNUP_FORM);
                    }
                  }}
                  className="underline teal-text"
                >
                  sign up now
                </Link>
              </p>
            </div>
          </div>
        </div>
      </SideImage>
    </>
  );
};

// Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  authentication: state.authentication,
  isShutterbAuthenticated: state.shutterbAuthentication.isShutterbAuthenticated,
  spinnerActions: state.system.spinnerActions,
});

// Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  onLoginClick: (data) => dispatch(loginActions.login(data)),

  onLoginWithFacebookClick: (data) =>
    dispatch(loginActions.loginWithFacebook(data)),

  onLoginWithGoogleClick: (data) =>
    dispatch(loginActions.loginWithGoogle(data)),
});

// mapping action and store the function via props
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(LogInForm));
